import { useState, useEffect } from 'react';
import './MobileStepper.scss';
import { useSelector } from 'react-redux';

const MobileStepper = ({ listSteps = [] }) => {
  const currentStep = useSelector((state) => state?.currentStep?.initialState);

  const [filteredSteps, setFilteredSteps] = useState([]);
  const [totalSteps, setTotalSteps] = useState([]);

  const filteredStepsForMobile = (steps) => {
    return steps.filter((el) => {
      return (
        Number(el.stepValues) === currentStep + 1 ||
        Number(el.stepValues) === currentStep + 2
      );
    });
  };

  const getWizardList = () => {
    const listOfSteps = listSteps.map((el, index) => {
      const temp = el;
      temp.stepValues = index + 1;
      return temp;
    });
    const stepsForMobile = filteredStepsForMobile(listOfSteps);
    const progresBarPercentage =
      ((stepsForMobile.length ? stepsForMobile[0].stepValues : 0) /
        listOfSteps.length) *
      100;

    document
      .querySelector(':root')
      .style.setProperty('--value', progresBarPercentage);

    setFilteredSteps(stepsForMobile);
    return listOfSteps;
  };

  useEffect(() => {
    setTotalSteps(getWizardList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <div className="progressMobile">
      {filteredSteps.length > 0 && (
        <>
          <div
            className="progressMobile__progressBar"
            role="progressbar"
            data-display={`${currentStep + 1} / ${totalSteps.length}`}
            // style="--value:66.66"
          />
          <div className="progressMobile__stepsNames">
            <div className="progressMobile__stepsNames_currentStep">
              {filteredSteps[0].stepperLabel}
            </div>
            <div className="progressMobile__stepsNames_nextStep">
              {filteredSteps[1] && `Next: ${filteredSteps[1].label}`}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MobileStepper;
